import { render } from "./DashUserForm.vue?vue&type=template&id=a34907e6"
import script from "./DashUserForm.vue?vue&type=script&setup=true&lang=js"
export * from "./DashUserForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/dash_user/components/DashUserForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a34907e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a34907e6', __exports__)) {
    api.reload('a34907e6', __exports__)
  }
  
  module.hot.accept("./DashUserForm.vue?vue&type=template&id=a34907e6", () => {
    api.rerender('a34907e6', render)
  })

}


export default __exports__